if (!customElements.get('old-whisky-rare-article')) {
  customElements.define(
    'old-whisky-rare-article',
    class OldWhiskyRareArticle extends HTMLElement {
      connectedCallback() {
        this.progress = this.querySelector('[data-owr-progress]');
        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.startVideo();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        const header =
          document.querySelector('#shopify-section-header .header') || document.querySelector('store-header');
        if (header) {
          const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
          this.style.setProperty('--owr-header-end', `${bottom}px`);
        }

        const start = this.offsetTop;
        const height = this.offsetHeight - window.innerHeight;
        const value = height > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / height)) : 0;
        if (this.progress) this.progress.style.width = `${value * 100}%`;
      }

      startVideo() {
        const video = this.querySelector('[data-owr-video]');
        if (!video || !video.dataset.src) return;
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const play = () => {
          if (video.querySelector('source')) return;
          const source = document.createElement('source');
          source.src = video.dataset.src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          video.load();
          video.play().catch(() => {});
        };

        if (document.readyState === 'complete') play();
        else window.addEventListener('load', play, { once: true });
      }
    }
  );
}
